import cloneDeep from 'lodash/cloneDeep';
import baseDefaults from '../Base/Base.defaults';
import baseButtonDefaults from '../BaseButton/BaseButton.defaults';
import baseImageDefaults from '../BaseImage/BaseImage.defaults';
import baseLabelDefaults from '../BaseLabel/BaseLabel.defaults';

export default {
  options: [],
  products: [
    {
      sku: 1,
      img_url:
        'https://res.cloudinary.com/ditbeukyz/image/upload/w_600,f_auto/milpiubelyyz9kdmueoy.png?cratio=600x600',
      img_urls: [],
      name: 'Waterpakjes',
      description:
        'Ondek Earth Water met een uniek bedrukt label in jouw eigen huisstijl! Hydrateer jezelf met lieve voor de planeet én een vluegje persoonlijke flair. Proost op duurzaamheid!',
      price_from: '100',
      price_label: 'Per 100',
      options: [
        {
          type: 'select',
          title: 'Formaat',
          options: [
            {
              title: '330ml',
            },
            {
              title: '500ml',
            },
          ],
        },
        {
          type: 'text',
          title: 'Indicatie aantal',
        },
      ],
    },
  ],
  afterSubmitAction: {},
  ...cloneDeep(baseDefaults),

  showDescription: false,

  showFeatured: true,

  gridLayout: 'design-1',

  featuredImage: cloneDeep(baseImageDefaults),

  featuredTitle: 'Laat je boodschap tot bloei komen',

  gridColor: 'var(--color-primary)',
};
